module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0008#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0009#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0010#pt01"
    }
  }, [_vm._v("Part One: The Depths")])]), _vm._v(" "), _c('p', {
    staticClass: "tocut"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0011#ut01"
    }
  }, [_c('span', {
    staticClass: "sm-i"
  }, [_vm._v("INTERLUDE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("1:")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("NUMBER")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("TWENTY-ONE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("JUNCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0012#ch01"
    }
  }, [_vm._v("1   What Obeah Does Do: Religion, Violence, and Law")])]), _vm._v(" "), _c('p', {
    staticClass: "tocut"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0013#ut02"
    }
  }, [_c('span', {
    staticClass: "sm-i"
  }, [_vm._v("INTERLUDE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("2:")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("VALLEY")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("DRY")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("BONES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0014#ch02"
    }
  }, [_vm._v("2   Experiments with Justice: On Turning in the Grave")])]), _vm._v(" "), _c('p', {
    staticClass: "tocut"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0015#ut03"
    }
  }, [_c('span', {
    staticClass: "sm-i"
  }, [_vm._v("INTERLUDE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("3:")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("BALANCE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("LOAD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0016#ch03"
    }
  }, [_vm._v("3   Electrical Ethics: On Turning the Other Cheek")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0017#pt02"
    }
  }, [_vm._v("Part Two: The Nations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocut"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0018#ut04"
    }
  }, [_c('span', {
    staticClass: "sm-i"
  }, [_vm._v("INTERLUDE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("4:")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("WHERE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("GANGES")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("MEETS")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("NILE,")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("I")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0019#ch04"
    }
  }, [_vm._v("4   Blood Lines: Race, Sacrifice, and the Making of Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocut"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0020#ut05"
    }
  }, [_c('span', {
    staticClass: "sm-i"
  }, [_vm._v("INTERLUDE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("5:")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("WHERE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("GANGES")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("MEETS")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("NILE,")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("II")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0021#ch05"
    }
  }, [_vm._v("5   A Tongue between Nations: Spiritual Work, Secularism, and the Art of Crossover")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0022#pt03"
    }
  }, [_vm._v("Part Three: The Heights")])]), _vm._v(" "), _c('p', {
    staticClass: "tocut"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0023#ut06"
    }
  }, [_c('span', {
    staticClass: "sm-i"
  }, [_vm._v("INTERLUDE")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("6:")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("ARLENA’S")]), _vm._v(" "), _c('span', {
    staticClass: "sm-i"
  }, [_vm._v("HAUNTING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0024#ch06"
    }
  }, [_vm._v("6   High Science")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0025#epil"
    }
  }, [_vm._v("Epilogue: The Ends of Tolerance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0026#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0027#refs"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosson0028#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f0a8d70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-crosson-0007.vue
// module id = 72
// module chunks = 0